import React from 'react'
import BgLayout from '../Components/Background/BgLayout'
import { Box, Container, Grid, useMediaQuery } from '@mui/material'
import { theme } from '../App';
import Navbar, { NAVBAR_SPACE } from '../Components/Navbar/Navbar';
import TitleTextLayout from '../Components/Background/TitleTextLayout';
import Advantages from '../Components/Advantages/Advantages';
import OftenAsked from '../Components/OftenAsked';
import { about_apps, mainPage } from './app_pages';
import Ratings from '../Components/Ratings/Ratings';
import AboutApp from '../Components/AboutApp/AboutApp';
import PartnersLine from '../Components/PartnersLine/PartnersLine';
import FunRatings from '../Components/Ratings/FunRatings';


export default function MainPage({ appPageData = mainPage }) {
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.only("sm"));
    const underSevenHundred = useMediaQuery("(max-width:700px)");

    return (
        <div>
            <Navbar color={appPageData.color} />
            <BgLayout color={appPageData.color}>
                <Grid
                    maxWidth={1200}
                    container
                    columns={24}
                    sx={{
                        mt: { xs: "20px", sm: "40px", md: "40px" },
                        px: NAVBAR_SPACE,
                    }}
                >
                    <Grid size={{ xs: 24, sm: 24, md: 12 }} sx={{}}>
                        <Box sx={{}}>
                            <TitleTextLayout
                                smTitle={appPageData.smTitle}
                                title={appPageData.title}
                                text={appPageData.text}
                                buttonText={appPageData.buttonText}
                                sxTitle={{ maxWidth: { xs: "100%", sm: "400px" } }}
                                sxText={{ maxWidth: "240px" }}
                                onButtonClick={() => {
                                    const el = document.getElementById("all_apps");
                                    if (el) {
                                        el.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            />

                        </Box>
                    </Grid>
                    <Grid

                        size={{ xs: 0, sm: 0, md: 12 }}
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "center", sm: "flex-end" },


                        }}
                    >
                        {<picture>
                            <source srcSet={appPageData.img} type="image/webp" />
                            <Box
                                component="img"
                                alt="Ukázka"
                                src={appPageData.img}
                                sx={[
                                    {
                                        position: "absolute",
                                        maxWidth: { xs: "340px", sm: "380px", md: "320px" },
                                        height: "auto",
                                        right: {
                                            xs: "0px",
                                            sm: "20px",
                                            md: "140px",
                                        },
                                        bottom: 0,
                                    },

                                ]}
                            />
                        </picture>}

                    </Grid>
                </Grid>
            </BgLayout>
            <Ratings />
            {about_apps.map((d, i) => {
                const about = <AboutApp appPageData={d} negativeRotate={i % 2 === 0} />
                if (i === 2) {
                    return <>
                        {about}
                        <PartnersLine />
                    </>
                } else {
                    return about;
                }
            })}
            <Advantages />
            <OftenAsked appPageData={appPageData} />
            <PartnersLine />
            <FunRatings bgcolor={"transparent"} />
        </div>
    )
}
